// import { useRouter } from 'vue-router'
// const router = useRouter();
const frameIn = [{
  path: '/login',
  name: 'Login',
  meta: {
    title: ''
  },
  component: () => import('@/views/socket/login')
}, {
  path: '/',
  name: 'socket',
  meta: {
    title: '奥利奥项目测试'
  },
  component: () => import('@/views/socket/index')
}];
/**
 * 错误页面
 */

const errorPage = [// {
//     path: '/403',
//     name: '403',
//     meta: {
//         title: '403'
//     },
//     component: () => import('@/views/system/error/403')
// },
// {
//     path: '/500',
//     name: '500',
//     meta: {
//         title: '500'
//     },
//     component: () => import('@/views/system/error/500')
// },
{
  path: '/:pathMatch(.*)',
  name: '404',
  meta: {
    title: '404'
  },
  component: () => import('@/views/system/error/404')
}];
export default [...frameIn, ...errorPage];